'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var modules_95586cb6 = {"container":"NumberInput_module_container__4d920be8"};
require("../../../assets/cjs/components/NumberInput/src/NumberInput~DZbTsKAN.css");

exports.default = modules_95586cb6;
//# sourceMappingURL=NumberInput.module.less.js.map
